// src/frontend_react/src/utils/icProcessor.js
export function cleanMalaysianIC(rawIcValue) {
  if (rawIcValue == null) return null;
  const icStr = String(rawIcValue).trim();
  if (!icStr) return null;
  const digitsOnly = icStr.replace(/\D/g, '');
  if (digitsOnly.length === 12) {
    const year = parseInt(digitsOnly.substring(0, 2), 10);
    const month = parseInt(digitsOnly.substring(2, 4), 10);
    const day = parseInt(digitsOnly.substring(4, 6), 10);
    // Basic date validity, can be enhanced (e.g. for leap years, days in month)
    if (month >= 1 && month <= 12 && day >= 1 && day <= 31) {
      // Check for birth century indication for more modern ICs if needed
      // For now, assume YY is valid as is for hashing purposes
      return digitsOnly;
    }
  }
  return null;
}